<!-- Минималистичный информационный блок для пустого состояния списка или раздела. -->
<template>
  <div class="empty-state" role="status">
    <span class="empty-state__icon" aria-hidden="true">
      <AppIcon :name="icon" :size="20" />
    </span>

    <div class="empty-state__content">
      <div class="empty-state__title">{{ title }}</div>
      <div v-if="description" class="empty-state__description">
        {{ description }}
      </div>
    </div>

    <div v-if="$slots.actions" class="empty-state__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "BaseEmptyState",

  components: {
    AppIcon,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: "info",
    },
  },
};
</script>

<style scoped>
.empty-state {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid #dbe3ec;
  border-radius: 8px;
  background: #fbfcfe;
}

.empty-state__icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #eef2ff;
  color: #4c6ef5;
}

.empty-state__content {
  min-width: 0;
  flex: 1;
}

.empty-state__title {
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
}

.empty-state__description {
  margin-top: 2px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.4;
}

.empty-state__actions {
  flex: 0 0 auto;
}

@media (max-width: 560px) {
  .empty-state {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .empty-state__actions {
    width: 100%;
    padding-left: 46px;
  }
}
</style>
